module.exports = __webpack_public_path__ + "static/media/ClarkColdVisuals-Logo-White.b82326ec.png";